export default {
  translation: {
    //General
    back: 'Zurück',
    skip: 'Später',
    retry: 'Wiederholen',
    refresh: 'Aktualisieren',
    reconnect: 'Neu Verbinden',
    reconnecting: 'Neu Verbindung',
    reload: 'Neu Laden',
    open: 'Öffnen',
    close: 'Schließen',
    ok: 'Ok',
    cancel: 'Abbrechen',
    save: 'Speichern',
    continue: 'Weiter',
    delete: 'Löschen',
    on: 'am',
    at: 'um',

    //Menu
    SEARCH: 'Suche',
    HOME: 'Home',
    SPECIAL: 'Speziell',
    SELECTED: 'Specials',
    FAVORITES: 'Favoriten',
    SPORTS: 'Sportarten',
    CATALOGUE: 'Katalog',
    CALENDAR: 'Kalender',
    SETTINGS: 'Einstellungen',
    PROFILE: 'Profil',
    FOCUS: 'Pay per View',
    OFFERS: 'Angebote',
    SETTINGS_EDIT_SPORTS: 'Sportarten',
    SETTINGS_EDIT_BROADCASTERS: 'Sportanbieter',
    SETTINGS_SUBSCRIPTIONS: 'Credits',
    SETTINGS_ACCOUNT: 'Account',
    SETTINGS_MANAGE_ACCOUNT: 'Konto und Abonnements verwalten',
    SETTINGS_DELETE_ACCOUNT: 'Meinen Account löschen',
    SETTINGS_LOGIN: 'Anmeldung',
    SETTINGS_LOGOUT: 'Ausloggen',
    SETTINGS_REGION: 'Region',
    SETTINGS_DEVELOPER: 'Entwickler',
    SETTINGS_SYS_INFO: 'Informationen zum System',
    SETTINGS_PLAYBACK: 'Playback',
    SETTINGS_IMPRINT: 'Impressum',
    SETTINGS_DATA_PRIVACY: 'Datenschutz',
    PREDICT: 'Tippspiel',
    SETTINGS_TERMS_CONDITIONS: 'Bedingungen',
    SETTINGS_COOKIE_BANNER: 'Cookie Banner',
    SMART_PREVIEW: 'Smart Preview',
    EVENT_PAGE: 'Detail page',
    MORE: 'Mehr',
    emptySubMenu: 'Hier gibt es leider noch nichts zu sehen.',

    //Settings
    yourCreditWallets: 'Dein Sportworld-Credit Guthaben',
    creditsInfo:
      'Sportworld-Credits sind dein flexibles Prepaid-Guthaben, mit dem du gezielt einzelne Live-Sportevents kaufen kannst - ganz ohne Abo-Verpflichtungen. Schau nur, was du sehen willst, und zahle nur, was du wirklich nutzt! Du kannst deine Sportworld-Credits in der Rubrik „Angebote“ in der Navigation kaufen.',
    promotionsInfo: 'Promotions-Credits ...',
    editSports: 'Meine Sportarten',
    selectProviers: 'Wähle die Sportarten aus, die dir in der Sportworld angezeigt werden sollen.',
    editBroadcasters: 'Meine Sportanbieter',
    selectBroadcasters: 'Wähle die Sportanbieter aus, deren Inhalte dir in der Sportworld angezeigt werden sollen.',

    //Welcome
    worldOfSportsInApp: 'Die Vielfalt des Sports in einer App',
    startSportworld: 'Starte Sportworld',
    voucherDescription: `Glückwunsch! Der Kauf deines Samsung Smart TVs berechtigt dich zu einem kostenlosen Voucher für unser Samsung Sport Paket.`,
    voucherTitle: 'Jetzt Voucher aktivieren!',
    availableForPhone: `Schon gewusst? Die Sportworld ist auch auf deinem Smartphone verfügbar. Hole dir jetzt die Sportworld-App auf dein Handy und profitiere von jeder Menge Zusatz-Features sowie einer innovativen Live-Sport-Experience.`,
    orSkip: 'oder überspringe den Login und starte sofort',

    //Close App
    exitApp: 'App Verlassen',
    aboutClosing1: 'Du bist gerade dabei, die Sportworld App zu schließen.',
    aboutClosing2: 'Bist du dir sicher, dass du die App verlassen willst?',
    goBack: 'Zurück',
    leaveApp: 'Verlassen',

    //Dialog
    confirmOpenAppIdTitle: 'Umschalten auf',
    anotherApp: 'eine andere Anwendung',
    confirmOpenAppIdDescription1: 'Du bist dabei, die',
    confirmOpenAppIdDescription2: 'zu öffnen',

    //EventHeading
    eventOver: 'Das Event ist bereits beendet.',
    nowLive: 'Jetzt live',
    liveToday: 'Heute Live',

    //Silder
    noEvents: 'Aktuell keine Events in Sichtweite. Schau später noch einmal vorbei.',
    live: 'Live',
    liveTV: 'Live TV',
    upcomingLive: 'Demnächst-Live',
    premiumPass: 'Pass',
    programInfoOnly: 'Programm-info',
    bought: 'Gekauft',
    viewAll: 'Alle anzeigen',
    viewMore: 'Mehr anzeigen',

    //VideoPlayer
    needSub: 'Für diesen Kanal benötigst du ein Sportworld-Abonnement.',
    channels247: '24/7-Kanäle',
    pressBack: 'Zurück',
    showLiveEvents: 'Live Events anzeigen',
    videoContentUnavailable: 'Dieses Video ist leider derzeit nicht verfügbar.',
    streamUnavailable: 'Dieser Stream ist leider derzeit nicht verfügbar.',
    ad: 'Werbung',
    adProgress: '{{currentAdIndex}} von {{adsNumber}}',
    eventVideoOver: 'Das Event ist zu Ende.',
    eventVideoOver2: 'Wir hoffen das Event hat Dir gefallen.',
    mediaVideoOver: 'Das Video ist zu Ende.',
    mediaVideoOver2: 'Wir hoffen das Video hat Dir gefallen.',
    eventStartsSoon: 'Event startet bald',

    //Notification
    setReminder: 'Erinnerung einstellen',
    removeReminder: 'Erinnerung entfernen',
    eventStartMessage: 'Das Event hat begonnen. Tippe jetzt auf die Benachrichtigung, um dir das Event anzusehen.',
    enableNotifications:
      'Deine Benachrichtigungen sind deaktiviert. Um Erinnerungen zu erhalten, musst du Benachrichtigungen der Sportworld in den Einstellungen erlauben.',
    eventStarts: 'Sportworld Reminder ⏰ Dein Event startet jetzt',

    //Share link
    shareLinkTitle: 'Das solltest du dir unbedingt ansehen! Jetzt in der Sportworld App.',
    shareText: 'Schau dir das Event an!',
    shareLink: 'Teilen',

    //Watch Now Button
    watchNow: 'Jetzt ansehen',
    playNow: 'Jetzt abspielen',
    startReplay: 'Wiederholung starten',
    startsIn: 'Startet in ',
    days: ' Tagen, ',
    hours: ' Stunden und',
    minutes: ' Minuten',
    counterDays: 'Tagen',
    counterHours: 'Stunden',
    counterMinutes: 'Minuten',
    counterSeconds: 'Sekunden',

    //QR Code
    qrInstruction1:
      'Scanne den QR-Code mit der Kamera-App deines Smartphones und folge den Anweisungen auf deinem Handy, um dich einzuloggen.',
    qrInstruction2: 'und gib folgenden Code manuell ein:',
    qrInstruction3: 'Oder geh auf',
    expiresIn: 'läuft ab in ',
    qrRefresh: 'Dein Code ist abgelaufen. Du kannst ohne Probleme auf deinem Handy weitermachen.',
    qrRefresh2: 'Du konntest den QR-Code noch nicht abscannen? Dann klicke hier, um nochmal zu starten:',

    //Login
    login: 'Login',
    loginAndWatch: 'Einloggen zum Ansehen',
    register: 'Registrieren',
    checkout: 'Checkout',
    selfservice: 'Account',
    logout: 'Logout',
    deleteMyAccount: 'Meinen Account löschen',
    deleteMyAccountInfo: 'Meinen Account löschen',
    deleteMyAccountPending: 'Deine Anfrage wird bearbeitet',

    registerCreated: 'Easy Registrierung via Smartphone',
    registerCreatedDescription: ``,
    loginCreated: 'Easy Login via Smartphone',
    loginCreatedDescription: '',
    checkoutCreated: 'Pass via Smartphone buchen',
    checkoutCreatedDescription: 'Sichere dir deinen Sportworld-Pass jetzt ganz bequem über dein Smartphone.',
    selfServiceCreated: 'Mein Account via Smartphone',
    selfServiceCreatedDescription:
      'Scanne den angezeigten QR-Code mit der Kamera-App deines Handys und verwalte deine Account-Daten sicher und schnell auf deinem Smartphone.',

    registerEntered: 'Easy Registrierung - Dein Smartphone übernimmt',
    registerEnteredDescription:
      'Kurze Pause für deinen Smart TV, denn jetzt geht es für dich am Handy weiter. Folge den Anweisungen auf deinem Smartphone, schalte deinen TV dabei nicht aus.',
    loginEntered: 'Easy Login - Dein Smartphone übernimmt',
    loginEnteredDescription:
      'Dein Smart TV wartet – jetzt ist dein Handy dran. Folge den Anweisungen auf deinem Smartphone und lass den TV eingeschaltet.',
    checkoutEntered: 'Dein Smartphone übernimmt',
    checkoutEnteredDescription:
      'Kurze Pause für deinen Smart TV, denn jetzt geht es für dich am Handy weiter. Folge den Anweisungen auf deinem Smartphone, schalte deinen TV dabei nicht aus.',
    selfServiceEntered: 'Mein Account - Dein Smartphone übernimmt',
    selfServiceEnteredDescription:
      'Kurze Pause für deinen Smart TV, denn jetzt geht es für dich am Handy weiter. Folge den Anweisungen auf deinem Smartphone, schalte deinen TV dabei nicht aus.',

    registerSuccess: 'Easy Registrierung erfolgreich',
    registerSuccessDescription:
      'Stark! Du bist jetzt auf deinem Smart TV und deinem Smartphone eingeloggt. Viel Spaß mit der Vielfalt des Sports und allen Features in deiner Sportworld.',
    loginSuccess: 'LOGIN ERFOLGREICH',
    loginSuccessDescription: 'Du bist jetzt auf deinem Smart TV eingeloggt und kannst direkt loslegen.',
    checkoutSuccess: 'Pass erfolgreich gebucht',
    checkoutSuccessDescription:
      'Super! Du hast deinen Sportworld-Pass erfolgreich gebucht. Viel Spaß mit der Vielfalt des Sports und allen Features in deiner Sportworld.',
    checkoutLoginSuccess: 'Login erfolgreich - jetzt nicht aufgeben',
    checkoutLoginSuccessDescription:
      'Du bist jetzt eingeloggt. Setze den Buchungsprozess weiter auf deinem Smartphone fort. Folge dazu den Anweisungen auf deinem Handy, schalte deinen TV dabei nicht aus.',
    selfServiceSuccess: 'Mein Account erfolgreich synchronisiert',
    selfServiceSuccessDescription:
      'Geschafft! Bearbeite jetzt deine persönlichen Daten, Sportworld-Pässe und Account-Details ganz bequem über dein Smartphone.',

    errorTitle: 'Hoppala, das hat leider nicht funktioniert.',
    errorLostConnection: `Die Verbindung zu deinem Smartphone wurde unterbrochen.\nScanne den QR-Code erneut und versuche dich neu zu verbinden.`,
    mobileOrComputerLogin: `Führe jetzt den Login-Prozess ganz bequem auf deinem Smartphone fort.\n`,

    //Account
    accountTitle: 'Mein Account',
    accountDescription:
      'Verwalte deine persönlichen Daten, Pässe und Credits bequem über dein Smartphone. Nutze den Login-Button, um dich schnell einzuloggen.',

    haveAccount: 'Du hast bereits einen Account?',
    dontHaveAccount: 'Du hast noch keinen Account?',
    needAccount: 'Nutze den Login-Button, um dich schnell und einfach mit deinem Smartphone einzuloggen.',

    pleaseAuthenticate: 'Jetzt Einloggen',
    youAreLoggedIn: 'Du bist jetzt eingeloggt!',
    userId: 'Kundennummer:',
    accountInstruction1:
      'Erstelle über den Account-Button einen QR-Code, der dich direkt zu deiner mobilen Account-Seite führt.',
    accountInstruction2: 'Alternativ kannst du diese mobile Webseite in deinem Browser nutzen:',
    accountInstructionUrl: 'https://account.sportworld.app/account',

    personalData: 'Persönliche Daten',
    customerId: 'Kunden-Nr.:',
    eMail: 'E-Mail:',
    paymentData: 'Zahlungsdaten',
    noPaymentData: 'Noch keine Zahlungsdaten',
    address: 'Adresse',
    billingAddress: 'Zahlungsadresse:',
    invoices: 'Rechnungen',
    noInvoices: 'Noch keine Rechnungen',
    subscriptions: 'Angebote',
    allSportsPackage: 'All Sports Paket',
    purchased: 'Gekauft:',
    creditCard: 'Kreditkarte:',
    nextBillingDate: 'Dein nächstes Zahlungsdatum ist',
    editData: 'Daten ändern',

    // Account Deletion
    accountDeletion: 'Account Löschen',
    accountDeletionDescription1: 'Bist du sicher, dass du deinen Account löschen willst?',
    accountDeletionDescription2: 'Falls ja, dann sende bitte eine Email an',
    accountDeletionDescription3: `mit dem Betreff: “Account Löschen”.`,

    //Consent
    consent: 'Einwilligung',
    legitimateInterest: 'Legitimes Interesse',
    consentTitle: 'Cookie Einstellungen',
    consentDescription:
      'Verwaltung der Zustimmung zur Erfassung und Verarbeitung personenbezogener Daten durch Technologien von Drittanbietern verwalten',

    //Events
    providerNotAvailable: 'Dieser Anbieter ist derzeit nicht in \n der Sportworld-App verfügbar.',

    //Pages
    contentUnavailable: 'Der Inhalt ist derzeit nicht verfügbar.',
    pageContentTypeUnavailable: 'Der Seitentyp {{pageType}} wird nicht unterstützt.',
    pagePromotionTokens: 'Promotion Tokens',

    //Stage
    learnMore: 'Erfahren Sie mehr',
    redeemVoucher: 'Gutschein einlösen',
    stagePromotionTokens: '{{walletName}} Token: {{count}}',

    //DataWidget
    dataWidgetTypeUnavailable: 'Der Daten-Widget-Typ {{dataWidgetType}} wird nicht unterstützt.',

    //Subscriptions
    subscriptionUnavailable: 'Abonnements nicht verfügbarAbonnements sind in Ihrer Region nicht verfügbar',
    subscriptionTitle: 'Meine Sportworld Angebote',
    subscriptionDescription:
      'Hier findest du eine Übersicht deiner verfügbaren Sportworld-Angebote. Mit diesen hast du Zugriff auf die ganze Vielfalt des Sports.',
    alreadyBought: 'Bereits gekauft',
    subscribe: 'Pass aktivieren',
    subscribed: 'Pass aktiv',
    moreInfo: 'Mehr Infos',

    //Errors
    cantCheckout: 'Checkout kann nicht ohne ausgewähltem Angebot fortgeführt werden.',
    appconfigLoadErrorTitle: 'Verbindung fehlgeschlagen',
    appconfigLoadErrorDescription:
      'Hoppala, leider konnte sich dein TV aufgrund eines technischen Problems nicht mit dem App-Dienst verbinden. Bitte versuche dich neu zu verbinden.',
    unavailableInRegion: 'Sportworld ist in deinem Land leider nicht verfügbar.',

    //DetailsPage
    notWatchable: 'Dieser Anbieter ist aktuell in keinem Sportworld-Pass enthalten. Öffne die App von ',
    appPoint: ', um dir das Event anzuschauen.',
    watchInYour: 'Du willst dir das Event anschauen? Dann öffne nach Ablauf des Countdowns die App von ',
    appPoint2: '.',

    //ExternalLinkOverlay
    externalLinkDescription: 'Leider können wir dieses Event nicht in der Sportworld App abspielen.',
    externalLinkLiveApp: 'Du bist dabei, die App zu verlassen und auf eine externe Website zu gehen',

    //Calendar
    today: 'Heute',
    tomorrow: 'Morgen',
    unlockPremium: 'Pässe öffnen',

    //Favorites
    emptyFavorites: 'Du hast noch keine Favoriten ausgewählt',
    addToFavorites: 'Zu Favoriten hinzufügen',
    favoritesUnavailable: 'Favoriten sind für registrierte Benutzer verfügbar',

    //Sports
    allSports: 'Alle Sportarten',
    highlights: 'Highlights',

    //Region page
    regionCardText:
      'Das Ändern der Option kann sich auf die Ereignisse, Videos und Kanäle auswirken, die Ihnen zur Verfügung stehen. Die Sprache der Sportworld-App wird nicht geändert',
    change: 'Ändern',
    availableRegions: 'Verfügbare Regionen',
    selectRegion: 'Wähle deine Region',
    noRegions: 'Keine Regionen verfügbar',

    //NFT create
    confirm: 'Bestätigen',
    nftExitDialog: 'Du bist gerade dabei, den NFT-Erstellungsassistenten zu verlassen. Bist du dir sicher?',
    aboutMintNft:
      'Mir ist bekannt, dass mein NFT mit Beginn des Rendering-Prozesses gemintet wird. Mit Abschluss des Rendering-Prozesses wird mein NFT freigeschalten und an die von mir hinterlegte Blockchain-Wallet geschickt.\nDas Widerrufsrecht habe ich gelesen. Ich stimme der Ausführung des Vertrages vor Ablauf der Widerrufsfrist zu und bestätige, dass ich durch meine Zustimmung mit Beginn der Ausführung des Vertrags mein Widerrufsrecht verliere und keine Rückerstattung erfolgt.',
    aboutClosingNft: 'Du bist gerade dabei, den NFT-Erstellungsassistenten zu verlassen. Bist du dir sicher?',
    leaveNft: 'Ja',
    stayNft: 'Nein',
    startNow: 'Jetzt starten',
    bindingBuy: 'Kaufen',

    //NFT info
    nftMintingFinished: 'Ihre NFT-Prägung ist bereits abgeschlossen',
    nftMintingFailed: 'Ihre NFT-Prägung ist fehlgeschlagen',
    createNftCubeInfoTitle: 'Gestalte deinen 3D-Würfel',
    createNftCubeInfoDescription:
      'Du erlebst eine spektakuläre Szene im Spiel? Dann halte diesen Moment in einem einzigartigen 3D-Würfel fest.',
    yourNftMomentInfoTitle: 'GESTALTE DEINEN 3D-WÜRFEL',
    yourNftMomentInfoDescription:
      'Personalisiere dein digitales Sammlerstück, indem du 4 Kameraperspektiven und eine Team-Seite auswählst.',
    connectWalletInfoTitle: 'Verbinde deine Wallet',
    connectWalletInfoDescription:
      'Verknüpfe deine Krypto-Wallet mit deinem Sportworld-Account und setze deine Credits zum Erwerb des NFTs ein.',
    secureNftInfoTitle: 'DIESER MOMENT GEHÖRT NUR DIR',
    secureNftInfoDescription:
      'Wir übernehmen das NFT-Minting für dich! Zahle in Sportworld Credits und sicher dir ein einzigartiges NFT, welches nur dir gehört und auf NFT-Marktplätzen wie OpenSea handelbar ist.',

    //NFT screens
    nftCreationHeader: 'Sportworld X ELF MyMoment',
    chooseYourSceneTitle: 'Wähle deine Szene',
    chooseYourSceneDescription:
      'Definiere deinen 6-Sekündigen Highlight-Moment. Schiebe dazu den Regler auf die gewünschte Position des Streams. Schau dir die Szene im nächsten Schritt aus unterschiedlichen Kameraperspektiven an.',
    sequenceAvailable: 'Diese Sequenz ist noch verfügbar',
    chooseCamerasTitle: 'Wähle deine {{camerasCount}} Kameras',
    chooseCamerasDescription:
      'Tippe auf die 4 Kameraperspektiven, die deinen gewählten Lieblings-Moment am besten zeigen. Über den „Play“-Button kannst du dir noch einmal deine Szene aus der entsprechenden Perspektive anschauen.',
    camerasChosen: 'Ausgewählte Kameras',
    camerasLeft: 'Kameras übrig',
    chooseCamerasError: 'Es wurden leider keine Kameras gefunden. Versuche es später nochmals.',
    customiseCubeTitle: 'INDIVIDUALISIERE DEINEN WÜRFEL',
    customiseCubeDescription:
      'Wähle dein Team! Oder entscheide dich für die neutrale Team-Variante. Wähle aus den drei Design-Optionen und definiere die letzte Seite des 3D-Würfels.',
    customiseCubeConfirm: 'Fertig zum Abschließen des Würfels, drücke bitte auf Bestätigen um Fortzufahren',
    customiseCubeBlocked: 'Es wurden leider keine Bilder gefunden. Versuche es später nochmals.',
    connectWalletTitle: 'Verbinde dein Wallet',
    connectWalletDescription:
      'Verbinde jetzt dein Blockchain-Wallet mit deinem Sportworld-Account, damit wir dir das NFT an dich übertragen können. Wichtig: Wähle als Blockchain-Netzwerk das „Polygon Mainnet“ aus.',
    walletConnected: 'Dein Wallet ist verbunden',
    connectWalletButton: 'Wallet ändern',
    connectWallet: 'Bitte verbinde dein Blockchain-Wallet',
    useCreditTitle: 'Setze deinen Credit ein',
    useCreditDescription:
      'Löse einen Credit im Wert von 133,33 EUR ein, um dir dieses NFT zu sichern. Wenn du bereits Credits besitzt, kannst du über den “KAUFEN-Button” den Mint-Prozess starten. Dir wird automatisch 1 Credit abgezogen.',
    availableCredits: 'Du hast {{ creditCount }} Credit(s) zur Verfügung',
    buyCredits: 'Credits hinzufügen',
    confirmNftMintingStart: 'Ich stimme zu',
    nftMinting: 'Dein nft wird jetzt gemintet',
    nftMintingDescription:
      'Glückwunsch! In wenigen Minuten gehört dir ein werthaltiges Stück “European League of Football”-Geschichte. Die Erstellung deines 3D-Würfels ist aufwendig und kann bis zu 30 Minuten dauern.\n\nSobald dein NFT fertig gemintet ist, zeigen wir dir hier deine Contract Address & ID an. Diese benötigst du, um das NFT in deiner Wallet anzeigen zu lassen.',
    contractAddressIdInfo: 'Sobald dir deine Vertrags-Adresse und ID angezeigt werden, kannst du die Seite verlassen.',
    nftSuccess: 'DAS WARTEN HAT SICH GELOHNT!',
    nftSuccessDescription:
      'Dein NFT ist nun fertig und wird automatisch an dein Blockchain-Wallet übertragen. Schon gewusst? Spiele das NFT jetzt im „NFT Sportshub“ in der Sportworld unter dem Reiter „MY NFT“ ab.',
    nftSuccesscontractAddressIdInfo: '',
    contractAddress: 'CONTRACT ADDRESS',
    contractId: 'ID',
    codeToDisplayNFT: 'Kopiere deine Vertrags-Adresse und ID in deine Krypto-Wallet.',
    backToStream: 'Zurück zum Stream',
    nftErrorTitle: 'Oh, etwas ist schief gelaufen',
    nftErrorDescription:
      'Leider ist ein Fehler aufgetreten. Die Gründe können vielfältig sein, vielleicht haben wir beide unsere Internet-Verbindung verloren. Wir arbeiten dran, dass das nicht wieder vorkommt. Keine Sorge, wir haben dir deinen Credit nicht abgebucht. Bitte starte den Rendering-Prozess erneut.',
    nftUniqueExitButton: 'Zurück zur Home',
    nftMintingInProgress: 'Ihr NFT befindet sich bereits in der Prägephase.',
    nftMintingConflict: `Sieht so aus als wird gerade ein NFT für dich erstellt werden. Bitte warte bis dein vorheriges NFT erstellt wurde, erst dann kannst du ein weiteres erzeugen.`,
    nftMintingHasFailed: `Leider ist ein Fehler aufgetreten. Die Gründe können vielfältig sein, vielleicht haben wir beide unsere Internet-Verbindung verloren. Wir arbeiten dran, dass das nicht wieder vorkommt. Keine Sorge, wir haben dir deinen Credit nicht abgebucht. Bitte starte den Rendering-Prozess erneut.`,
    nftMintingInProgressDescription: 'Dein NFT wird geminted. Tippe hier, um den Fortschritt zu sehen',

    //NFT limited
    nftLimitedCreationHeader: 'Sportworld x ELF Limited',
    price: 'Preis',
    limitationNftPieces: 'Limitierung: {{nftCount}} Stück',
    limitation: 'Limitierung',
    items: 'Stück',
    connectBlockchainWallet: 'Bitte verbinde dein Blockchain-Wallet',
    buy: 'Kaufen',
    processing: 'Wird bearbeitet ...',
    confirmBuyNFTTitle: 'BESTÄTIGE DEINEN KAUF',
    confirmBuyNFTDescription:
      'Ich stimme der Ausführung des Vertrages vor Ablauf der Widerrufsfrist zu und bestätige, dass ich durch meine Zustimmung mit Beginn der Ausführung des Vertrags mein Widerrufsrecht verliere und keine Rückerstattung erfolgt.',
    congratulationsNftPurchase: 'Glückwunsch, dieses NFT gehört dir!',
    purchaseIsNotAvailable: 'Kauf ist nicht verfügbar',

    qrTitle: 'JETZT QR-CODE SCANNEN, um...',
    qrText1:
      '...zu deiner Contract ID und deiner Contract Address zu gelangen. Diese benötigst du, um das NFT auch in deiner Wallet anzeigen zu können.',
    qrText2: '....Wallet zu verbinden \n ....Credits zu kaufen',
    purchasedTitle: 'Glückwunsch, dieses NFT gehört dir!',
    purchasedText1: 'VON DIESEM NFT EXISTIEREN NUR',
    purchasedText2: 'STÜCK',
    creditsAmount1: 'Du hast',
    creditsAmount2: 'Credit(s) zur Verfügung',
    claimErrorTitle: 'NFT-Anspruchsfehler',
    generalErrorTitle: 'Fehlermeldung',
    walletsErrorDesc:
      'Irgendwas ist schief gelaufen. Überprüfen bitte deine Credits und deine Krypto-Wallet und versuche es erneut.',
    generalErrorDesc: 'Irgendwas ist schief gelaufen. Bitte versuchen es später noch einmal.',

    //Predict
    loginAgain: 'Erneut anmelden',
    predictLoginError: 'Leider gab es einen Fehler beim Laden des Tippspiels.\nLogge dich bitte erneut ein.',

    //CopyInput
    copy: 'Kopieren',
    copied: 'Kopiert',
    copyInputMessage: '{{type}} wird in deine Zwischenablage kopiert',

    // ForceUpdate
    update: 'Update',
    closeTheApp: 'Schließen',
    forceUpdateDescriptionTizen:
      'Diese Version von Sportworld wird nicht mehr unterstützt. Bitte aktualisieren Sie auf eine neue Version im Tizen App Store.',
    forceUpdateDescriptionMobile:
      'Diese Version von Sportworld wird nicht mehr unterstützt. Bitte aktualisieren Sie auf eine neue Version im App Store.',
    forceUpdateDescriptionIOS:
      'Diese Version von Sportworld wird nicht mehr unterstützt. Bitte aktualisieren Sie auf eine neue Version im App Store.',
    forceUpdateDescriptionAndroid:
      'Diese Version von Sportworld wird nicht mehr unterstützt. Bitte aktualisieren Sie auf eine neue Version im Play Market.',

    soccerData: {
      toLiveStreamButtonText: 'ZUM LIVE-DATA STREAM',
      vs: 'VS.',
      matches: {
        noDate: 'Datum in nicht verfügbar',
        noData: {
          text: 'Diese Woche finden keine Spiele statt',
        },
        tournamentNotStarted: {
          text: '{{name}} hat noch nicht begonnen...',
          button: 'Weiter zur ersten Woche',
        },
        tournamentFinished: {
          text: '{{name}} ist bereits fertig...',
          button: 'Gehe zur letzten Woche',
        },
      },
      standings: {
        noData: {
          text: 'Keine Tabelleninformationen verfügbar',
        },
      },
    },
    search: {
      title: 'Suchergebnisse',
      errorText: 'Irgendetwas ist schief gelaufen...',
      suggestions: 'Vorschläge',
      noSuggestionsText: 'Keine Vorschläge gefunden',
      input: {
        placeholder: 'Suche',
      },
      lines: {
        noDataText: 'Keine Ergebnisse gefunden',
      },
      itemsList: {
        noItemsText: 'Keine Daten',
        event: 'Ereignisse',
        page: 'Seiten',
      },
      tabs: ['Veranstaltungen', 'Seiten'],
    },
    detailPage: {
      eventNotFound: 'Content ist nicht mehr verfügbar',
      unhandledError: 'Etwas ist schief gelaufen',
      goHome: 'Zur Startseite gehen',
      watchForSamsungCredits: 'Jetzt freischalten',
      watchForSamsungCredits_plural: 'Jetzt freischalten',
      information: {
        purchaseByCredits:
          'Hol dir jetzt Zugriff auf das Live-Event für <span>{{cost}} Credit</span> (entspricht €\u00a0{{euro}}).',
        purchaseByCredits_plural:
          'Hol dir jetzt Zugriff auf das Live-Event für <span>{{cost}} Credits</span> (entspricht €\u00a0{{euro}}).',
        redirectToChanel:
          'Dieses Programm läuft im {{-providerName}}. Du wirst von uns direkt zum Anbieter weitergeleitet.',
        availableInApp:
          'Dieses Programm ist derzeit nur bei {{-providerName}} verfügbar. Möglicherweise ist ein Abo erforderlich.',
        liveUnavailable:
          'Das Event ist live, aber noch nicht in der Sportworld verfügbar. Bleibe dran, um Updates zu erhalten, wann es bei uns verfügbar sein wird.',
        upcomingUnavailable:
          'Dieses Event startet bald, aber ist noch nicht bei uns verfügbar. Wir arbeiten daran, den Sender bald anzubieten.',
        loginToWatch:
          'Bitte logge dich ein, um dieses Event sehen zu können. Möglicherweise ist ein Sportworld Pass erforderlich.',
        freeChannel: 'Live dabei! Dieses Event läuft gerade - und du kannst kostenlos mit dabei sein!',
        availablePremiumChannel: 'Du bist für dieses Event freigeschaltet. Sei live dabei.',
        futureAvailablePremium:
          'Du bist bereits freigeschaltet. Der Countdown läuft - schon bald kannst du dir das Event anschauen.',
        needSubscription:
          'Das Event ist live! Schalte jetzt ein und erlebe das Spektakel. Du benötigst ein Abo, um das Spiel zu sehen.',
        waitCountdownEnds: 'Das Event startet bald und du kannst kostenlos dabei sein! Verpasse es nicht!',
        waitCountdownEndsPremium:
          'Bald geht es los! Sichere dir rechtzeitig dein Abo, um das Event nicht zu verpassen.',
        premiumPackIsRequired: 'Dieser Inhalt benötigt das PREMIUM PACK um abgespielt zu werden.',
        scanQr:
          'Dieser Inhalt benötigt das PREMIUM PACK um abgespielt zu werden. Bitte scanne den QR Code um deine Abonnements zu verwalten und ggf. das benötigte Pack zu buchen.',
      },
    },
    ppvPopup: {
      buttonGetMoreCredits: 'Hol dir credits',
      purchased: 'Gekauft',
      payPerView: 'Pay Per View',
      promotion: 'Promotion',
      orderOverview: 'Bestellübersicht',
      redeemCredit: 'JETZT FREISCHALTEN',
      credit: 'Guthaben',
      credit_plural: 'Guthaben',
      toEvent: 'Zum Event',
      watchLater: 'Später ansehen',
      successfulPurchase: 'Dein Kauf war erfolgreich.',
      agreement:
        'Wenn du auf “Jetzt freischalten” klickst, steht dir das Event zur Verfügung und du stimmst zu, dass keine Rückerstattung möglich ist, wenn das Event angesehen oder heruntergeladen wurde. Mit der Bestellung oder Wiedergabe erklärst du dich mit unseren Allgemeinen Geschäftsbedingungen auf sportworld.app einverstanden. Verkauft von B1SmartTV GmbH.',
      isNotEnoughCredits:
        'Für dieses Event reicht dein Credit-Guthaben leider nicht aus. Scan den QR-Code, um dein Credit-Guthaben aufzufüllen.',
      actualCredits: '{{creditsName}}-Guthaben',
      requiredCredits: 'Benötigtes {{creditsName}}-Guthaben',
      creditsLeftAfterPurchase: '{{creditsName}}-Guthaben nach dem Kauf',
      selectCredits: 'Credits zum Einlösen auswählen',
      redeemFailed: 'Etwas ist schief gelaufen',
      redeemFailedInfo: 'Leider ist beim Einlösen deiner Credits etwas schief gegangen.\n Bitte versuche es erneut.',
      eventAlreadyRunning: 'Das Event läufts bereits',
      warningInfo:
        'Das Live Event <span>{{name}}</span> begann <span>um {{startTime}}</span> und wird <span>bis {{endTime}}</span>. Du kannst direkt ab dem aktuellen Zeitpunkt live einsteigen, jedoch nicht von Anfang an starten.',
      warningInfo2: 'Möchtest du für das Event deine Credits trotzdem einlösen?',
    },
    pageFallback: {
      content:
        'Diese Seite ist derzeit nicht verfügbar.\nVersuchen Sie, sie neu zu laden oder gehen Sie zurück zur Startseite.',
      buttons: ['Retry', 'Home'],
    },
    toasts: {
      sessionExpired: 'Deine Sitzung ist abgelaufen, bitte melde dich erneut an.',
      promotionLaunchFailed:
        'PromotionApp nicht gefunden: {{promotionAppID}}. Bitte überprüfe, ob die Promotion-App installiert ist.',
      appNotFound: '{{appName}} wurde nicht gefunden. Bitte überprüfe, ob die App installiert ist.',
      configIsNotAccessible:
        'Leider konnten einige App-Informationen nicht geladen werden. Einige Funktionen könnten eingeschränkt sein.',
      favoriteIsUnavailable: 'Favoriten  ist derzeit nicht verfügbar.',
    },
    tune: {
      noChannels: 'Leider konnten wir keine TV-Sender finden.',
      noChannel: 'Leider konnten wir den TV-Sender nicht finden.',
      cantTune: 'Leider konnten wir nicht auf den TV-Sender tunen.',
    },
    dataWidget: {
      standing: {
        pl: 'Pl',
        team: 'Mannschaft',
        mp: 'Sp',
        md: 'US',
        w: 'S',
        d: 'U',
        l: 'N',
        goals: 'Tore',
        gd: 'Diff',
        pts: 'Pkt',
      },
      commentary: {
        'noData': 'Es gibt keine Spiele in diesem Zeitraum',
        'matchStartsAt': 'Dieses Spiel beginnt um',
        'matchStarts': 'Dieses Spiel beginnt',
        'noCommenteryData': 'Es gibt keinen Live Ticker für dieses Spiel',
        'backToOverview': 'Zurück zur Übersicht',
        'minute': 'Minute',
        'assist': 'Assist',
        'attempt blocked': 'Schuss geblockt',
        'attempt saved': 'Chance verhindert',
        'comment': 'Kommentar',
        'comment_auto': 'Automatischer Kommentar',
        'comment_important': 'Wichtiger Kommentar',
        'comment_mixed': 'Gemischter Kommentar',
        'contentious referee decisions': 'Umstrittene Schiedsrichterentscheidung',
        'corner': 'Ecke',
        'Deleted after review': 'Gelöscht nach Überprüfung',
        'end 1': 'Ende der ersten Halbzeit',
        'end 2': 'Ende der zweiten Halbzeit',
        'end 3': 'Ende der Verlängerung - Erste Halbzeit',
        'end 4': 'Ende der Verlängerung - Zweite Halbzeit',
        'end 5': 'Ende des Elfmeterschießens',
        'end 10': 'Halbzeitpause',
        'end 11': 'Ende der zweiten Halbzeit - vor der Verlängerung',
        'end 12': 'Verlängerung - Halbzeitpause',
        'end 13': 'Ende der Verlängerung - Elfmeterschießen',
        'end 14': 'Ende der regulären Spielzeit',
        'end 16': 'Ende des Vorspiels',
        'end delay': 'Ende der Verzögerung',
        'free kick lost': 'Freistoß',
        'free kick won': 'Freistoß',
        'full time': 'Spielende',
        'goal': 'Toooor!',
        'half time': 'Halbzeit',
        'half_time summary': 'Zusammenfassung der Halbzeit',
        'highlight': 'Highlight',
        'kick off': 'Anstoß',
        'lineup': 'Aufstellung',
        'miss': 'Fehlschuss',
        'offside': 'Abseits',
        'own goal': 'Eigentor',
        'penalty': 'Elfmeter',
        'penalty goal': 'Elfmetertor!',
        'penalty lost': 'Elfmeter',
        'penalty miss': 'Elfmeter vergeben',
        'penalty_so goal': 'Elfmetertor!',
        'penalty_so miss': 'Elfmeter vergeben',
        'penalty save': 'Elfmeter gehalten',
        'penalty saved': 'Elfmeter gehalten',
        'penalty won': 'Elfmeter',
        'player retired': 'Spieler zurückgetreten',
        'post': 'Pfosten',
        'postponed': 'Verschoben',
        'post-match summary': 'Zusammenfassung nach dem Spiel',
        'pre kick off': 'Vor dem Anstoß',
        'red card': 'Rote Karte',
        'second half': 'Zweite Halbzeit',
        'secondyellow card': 'Gelb-Rote Karte',
        'second_yellow red card': 'Gelb-Rote Karte',
        'start': 'Start',
        'start delay': 'Verzögerung',
        'stats': 'Statistiken',
        'substitution': 'Auswechslung',
        'team news': 'Mannschaftsnachrichten',
        'var': 'Video Assistent Referee',
        'yellow card': 'Gelbe Karte',
        'VAR cancelled goal': 'Tor durch VAR annulliert',
      },
    },
    // Feature Screen
    featureScreen: {
      continueToSportWorld: 'weiter zu SportWorld',
      goToChannel: 'zum Kanal gehen',
    },
    // Payment Popup
    paymentPopup: {
      title: 'Zahlungsmethode wählen',
      yourCredits: 'Deine Credits: {{credits}}',
      purchaseByCredits: 'Event freischalten für <span>{{cost}} Credit</span>',
      purchaseByCredits_plural: 'Event freischalten für <span>{{cost}} Credits</span>',
      continueWithCredits: 'Credits Package Auswählen',
    },
    smartAppBanner: {
      view: 'Anzeigen',
      free: 'KOSTENLOS',
      appStore: 'Im App Store',
      googlePlay: 'In Google Play',
    },
  },
}
